const timeframeOptions = [
    '1m',
    '5m',
    '15m',
    '30m',
    '1H',
    '4H',
    '1D',
    '1W',
    '1M',
];
const TimeframeFields = ({
    timeframe = '',
    dateRange = { start: '', end: '' },
    onTimeframeChange = () => {},
    onDateRangeChange = () => {},
    errors = {},
}) => {
    return (
        <div id="timeframe-column" className="form-column">
            <label id="timeframe-label" htmlFor="timeframe-1m">
                2. Select a Timeframe
            </label>
            <div
                className="timeframe-options"
                role="group"
                aria-labelledby="timeframe-label"
                aria-describedby={
                    errors.timeframe ? 'timeframe-error' : undefined
                }
            >
                {timeframeOptions.map((option) => (
                    <button
                        key={option}
                        id={`timeframe-${option}`}
                        type="button"
                        className={`timeframe-option${
                            timeframe === option ? ' selected' : ''
                        }`}
                        aria-pressed={timeframe === option}
                        onClick={() => onTimeframeChange(option)}
                    >
                        {option}
                    </button>
                ))}
            </div>
            {errors.timeframe && (
                <p className="form-validation-error" id="timeframe-error">
                    {errors.timeframe}
                </p>
            )}
            <div className="date-range-fields">
                <p className="date-range-label">Date Range</p>
                <div className="date-inputs">
                    <label className="sr-only" htmlFor="start-date">
                        Start Date
                    </label>
                    <input
                        id="start-date"
                        name="start-date"
                        type="date"
                        value={dateRange.start}
                        aria-describedby={
                            errors.dateRange ? 'date-range-error' : undefined
                        }
                        aria-invalid={Boolean(errors.dateRange)}
                        onChange={(e) =>
                            onDateRangeChange({
                                ...dateRange,
                                start: e.target.value,
                            })
                        }
                    />
                    <span className="date-range-arrow" aria-hidden="true">
                        &rarr;
                    </span>
                    <label className="sr-only" htmlFor="end-date">
                        End Date
                    </label>
                    <input
                        id="end-date"
                        name="end-date"
                        type="date"
                        value={dateRange.end}
                        aria-describedby={
                            errors.dateRange ? 'date-range-error' : undefined
                        }
                        aria-invalid={Boolean(errors.dateRange)}
                        onChange={(e) =>
                            onDateRangeChange({
                                ...dateRange,
                                end: e.target.value,
                            })
                        }
                    />
                </div>
                {errors.dateRange && (
                    <p className="form-validation-error" id="date-range-error">
                        {errors.dateRange}
                    </p>
                )}
            </div>
        </div>
    );
};

export default TimeframeFields;
